module.exports = __webpack_public_path__ + "static/img/JiuXiang_Banner_summer.16b9573a.jpg";